const e = {
  name: "Book",
  dimensions: { width: 16, height: 20 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4 5C4 4.44772 4.44772 4 5 4H11C11.5523 4 12 4.44772 12 5C12 5.55228 11.5523 6 11 6H5C4.44772 6 4 5.55228 4 5Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 7H11C11.5523 7 12 7.44772 12 8C12 8.55229 11.5523 9 11 9H5C4.44772 9 4 8.55229 4 8C4 7.44772 4.44772 7 5 7Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H15C15.5523 0 16 0.447715 16 1V19C16 19.5523 15.5523 20 15 20H3C2.20435 20 1.44129 19.6839 0.87868 19.1213C0.316071 18.5587 0 17.7957 0 17V3C0 2.20435 0.316071 1.44129 0.87868 0.87868ZM2 14.1716V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H14V14H3C2.65606 14 2.3182 14.0591 2 14.1716ZM14 16H3C2.73478 16 2.48043 16.1054 2.29289 16.2929C2.10536 16.4804 2 16.7348 2 17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H14V16Z" fill="currentColor"/>
    `
};
export {
  e as Book
};
